import { type IEquipmentListParams } from 'domains/equipments/list/services/types'

export const INITIAL_STATE_FILTER: IEquipmentListParams = {
  page: 1,
  termo: undefined,
  category: undefined,
}
